<template>
  <SectionTemplate
    title="从脚本到镜头，轻松掌控每一个视频细节"
    subTitle="3D AI 视频编辑"
    class="detail-section-container"
  >
    <VideoCarousel
      :showControls="false"
      :infos="featureList"
      class="detail-carousel"
      :muted="true"
    />
    <ArrowBtn variant="black-common" text="免费试用" class="detail-btn" @click="$emit('trial')" />
  </SectionTemplate>
</template>

<script setup lang="ts">
import ArrowBtn from '~/design/components/buttons/arrow-btn.vue';
import SectionTemplate from '~/design/widgets/landing-section/cn-template.vue';
import { getFeUrl } from '~/utils/url';
import VideoCarousel from '../../components/video-carousel.vue';

const featureList = [
  {
    title: `编辑脚本与PPT`,
    subTitle: '编辑脚本与PPT，内容随时修改，视频也能随时迭代',
    desc: `内容更新节奏快，视频修改怎么跟得上？
直接上传或修改脚本与PPT，几秒内即可生成最新视频。省去重复拍摄与剪辑，轻松应对产品发布、课程更新、活动变动等内容高频迭代需求。`,
    url: getFeUrl('/youyan-platform/main/control-every-detail/detail-1.webm'),
    poster: getFeUrl(
      '/youyan-platform/main/control-every-detail/detail-1.png?x-oss-process=image/format,webp',
    ),
    videoDesc: '在有言的AI视频创作中可以灵活修改脚本和PPT',
  },

  {
    title: `编辑人物角色`,
    subTitle: '轻松切换不同风格的视频主角',
    desc: `数千款超写实3D数字人任你选择，亲和讲师、商务讲解、日常休闲应有尽有，一键替换即刻上镜。还支持形象的个性化调整，让每条视频都能拥有专属主角出镜。`,
    url: getFeUrl('/youyan-platform/main/control-every-detail/detail-2.webm'),
    poster: getFeUrl(
      '/youyan-platform/main/control-every-detail/detail-2.png?x-oss-process=image/format,webp',
    ),
    videoDesc: '有言提供数千款AI数字人可以随时编辑和切换',
  },
  {
    title: `添加动作与表情`,
    subTitle: '人物表达更具感染力',
    desc: `一键添加点头、手势、指向等动作，高效突出内容重点。还能添加笑容、严肃、困惑等情绪，配合语音语调，全面还原真人表达，讲什么都更有说服力。`,
    url: getFeUrl('/youyan-platform/main/control-every-detail/detail-3.webm'),
    poster: getFeUrl(
      '/youyan-platform/main/control-every-detail/detail-3.png?x-oss-process=image/format,webp',
    ),
    videoDesc: '在有言AI数字人视频中人物的表情和动作随时可以编辑',
  },
  {
    title: `一键切换3D场景`,
    subTitle: '画面氛围一秒拉满',
    desc: `无论是发布会舞台、新闻演播室还是教室讲台，你想要的拍摄现场，我们都为你准备好了。无需布景，无需搭建，近千款3D高质量场景随你选，轻松打造沉浸式画面。`,
    url: getFeUrl('/youyan-platform/main/control-every-detail/detail-4.webm'),
    poster: getFeUrl(
      '/youyan-platform/main/control-every-detail/detail-4.png?x-oss-process=image/format,webp',
    ),
    videoDesc: '在有言AI数字人视频中背景和3D场景随时可以编辑',
  },
  {
    title: `编辑镜头`,
    subTitle: '像专业导演一样轻松切换拍摄视角',
    desc: `无需拍摄团队，也不用剪辑经验，只需点击几下，即可实现远景、中景、特写、画中画等多机位运镜效果。内容更聚焦、节奏更明快，轻松呈现专业级视觉效果。`,
    url: getFeUrl('/youyan-platform/main/control-every-detail/detail-5.webm'),
    poster: getFeUrl(
      '/youyan-platform/main/control-every-detail/detail-5.png?x-oss-process=image/format,webp',
    ),
    videoDesc: '在有言AI数字人视频中提供多样的镜头让视频更加有趣生动',
  },
  {
    title: `添加后期包装`,
    subTitle: '视频润色一步到位',
    desc: `高质量字幕样式、片头片尾、贴纸花字和背景音乐一应俱全，无需切换软件，在有言即可一站完成视频包装，轻松做出风格统一、重点突出的视频成片。`,
    url: getFeUrl('/youyan-platform/main/control-every-detail/detail-6.webm'),
    poster: getFeUrl(
      '/youyan-platform/main/control-every-detail/detail-6.png?x-oss-process=image/format,webp',
    ),
    videoDesc: '在有言AI数字人视频中提供多样的视频包装让视频更加有趣生动',
  },
];
</script>
<style lang="scss" scoped src="./styles/pc.scss" />
<style lang="scss" scoped src="./styles/mobile.scss" />
